import { useEffect } from 'react';

// intersectionObservers
export const useIntersectionObservers = (ref, setIsVisible, setActive) => {

    useEffect(() => {
        const visibilityObserver = new IntersectionObserver(
            ([entry]) => {
                if (entry.isIntersecting) {
                    setIsVisible(true);
                }
            },
            {
                root: null,
                rootMargin: '0px',
                threshold: 0.1,
            }
        );

        let activeObserver;

        if (window.innerWidth >= 1200) {
            activeObserver = new IntersectionObserver(
                ([entry]) => {
                    if (entry.isIntersecting) {
                        setActive(ref.current && ref.current.id);
                    }
                },
                {
                    root: null,
                    rootMargin: '0px',
                    threshold: 0.9,
                }
            );
        }

        if (ref.current) {
            visibilityObserver.observe(ref.current);
            if (activeObserver) {
                activeObserver.observe(ref.current);
            }
        }


        return () => {
            if (ref.current) {
                visibilityObserver.unobserve(ref.current);
                if (activeObserver) {
                    activeObserver.unobserve(ref.current);
                }
            }
        };
    }, [ref, setIsVisible, setActive]);
};
